var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4655 43.8579L31.4141 2.19979C30.7016 0.965497 29.4253 0.228638 28 0.228638C26.5747 0.228638 25.2984 0.965497 24.5859 2.19979L0.534516 43.8579C-0.178172 45.0922 -0.178172 46.566 0.534516 47.8002C1.24709 49.0345 2.52339 49.7713 3.94866 49.7713H52.0513C53.4766 49.7713 54.7529 49.0345 55.4655 47.8002C56.1782 46.566 56.1782 45.0922 55.4655 43.8579ZM52.6204 46.1576C52.5497 46.2803 52.3813 46.4862 52.0515 46.4862H3.94866C3.61856 46.4862 3.45034 46.2804 3.37969 46.1576C3.30892 46.035 3.21464 45.7864 3.37969 45.5006L27.4309 3.84239C27.596 3.55659 27.8582 3.51382 27.9999 3.51382C28.1416 3.51382 28.4039 3.55648 28.5689 3.84239L52.6203 45.5006C52.7855 45.7864 52.6912 46.035 52.6204 46.1576Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6447 15.1666H26.3594V32.6882H29.6447V15.1666Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 40.3539C29.2104 40.3539 30.191 39.3733 30.191 38.1636C30.191 36.954 29.2104 35.9734 28.0008 35.9734C26.7912 35.9734 25.8105 36.954 25.8105 38.1636C25.8105 39.3733 26.7912 40.3539 28.0008 40.3539Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.29052292.svg";
export { ForwardRef as ReactComponent };